import { ContractBasicData } from '../types/contract';
import { EmablerTariffElementUI, EvChargingStatus } from '../types/evCharging';
import { capitalizeFirstLetter } from './consumption';

export const contractIsEvCharging = (contract: ContractBasicData) => {
  return contract.contractTypeNo === '26';
};

export const formatTag = (tag: string): string =>
  tag
    .toUpperCase()
    .replace(/(.{4})/g, '$1 ')
    .trim();

export const formatChargerId = (id: string) => {
  return id.substring(9, 0);
};

export const formatWatts = (power: number) => {
  return `${(power / 1000).toString().replace('.', ',')} kW`;
};

export const isCharging = (chargerStatus: EvChargingStatus) => chargerStatus.status === 'STARTED' || chargerStatus.status === 'CHARGING';

function daysForLocale(localeName = 'fi', weekday: 'long' | 'short' = 'short') {
  const format = new Intl.DateTimeFormat(localeName, { weekday }).format;
  const now = new Date();
  const currentDay = now.getDay(); // Sunday is 0, Monday is 1, etc.

  // Generate an array [1, 2, 3, 4, 5, 6, 0] => Monday to Sunday
  const weekOrder = [1, 2, 3, 4, 5, 6, 0];

  return weekOrder.map((day) => {
    // Calculate the offset from today to the desired day
    const diff = (day - currentDay + 7) % 7;
    const date = new Date(now.getTime() + diff * 86400000);
    return format(date);
  });
}

export const formatDays = (days: string[]) => {
  const dayOrder = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const;
  type DayName = (typeof dayOrder)[number];
  const shortNames = daysForLocale();

  // Sort input days according to dayOrder
  const sortedDays = dayOrder.filter((day) => days.includes(day));

  const result: string[] = [];
  let rangeStart: DayName | null = null;

  for (let i = 0; i <= sortedDays.length; i++) {
    const current = sortedDays[i];
    const prev = sortedDays[i - 1];

    if (i === 0 || dayOrder.indexOf(current) === dayOrder.indexOf(prev) + 1) {
      if (rangeStart === null) {
        rangeStart = prev || current;
      }
    } else {
      if (rangeStart === prev) {
        result.push(capitalizeFirstLetter(shortNames[dayOrder.indexOf(rangeStart)]));
      } else {
        if (rangeStart !== null) {
          result.push(
            `${capitalizeFirstLetter(shortNames[dayOrder.indexOf(rangeStart)])}–${capitalizeFirstLetter(shortNames[dayOrder.indexOf(prev)])}`,
          );
        }
      }
      rangeStart = current;
    }
  }

  return result.join(', ');
};

export const renderHours = (element: EmablerTariffElementUI): string => {
  return `${element.timeRestrictions?.startHour.toString().padStart(2, '0')}–${element.timeRestrictions?.endHour.toString().padStart(2, '0')}`;
};
